import React from "react";
import { useNavigate } from "react-router-dom";
import Div100vh from "react-div-100vh";

import { ArrowRight } from "lucide-react";
import { callHelpMessage, chatHelpMessage } from "@/lib/helper";
import GoBackButton from "@/components/common/buttons/GoBackButton";
import WhatsappIcon from "@/assets/icons/whatsapp-icon.webp";
import CallIcon from "@/assets/icons/Vector2.png";

import BackgroundImage from "@/assets/images/landlord-background.png";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";

export default function ContactScreen({ invalidReferral = false }) {
  const navigate = useNavigate();

  return (
    <Div100vh
      className="flex flex-col py-8 px-8 justify-between"
      style={{ backgroundImage: `url(${BackgroundImage})` }}
    >
      <div className="flex flex-col gap-24">
        <GoBackButton customBackSubmit={() => navigate("/benefits")} />
        <div className="flex flex-col gap-16 w-full">
          <span className="xs:text-xl sm:text-2xl font-semibold">
                  
             {"Thank you for accepting the invite, our team will be getting in touch soon!"}
          </span>
          <span className="text-[#999999] xs:text-lg sm:text-xl">
            {invalidReferral
              && "Got any questions for us?"}{!invalidReferral &&
               "Got any questions for us?"}
          </span>
          <div className="flex gap-4 justify-center items-center">
          <button onClick={() => chatHelpMessage()} className="bg-slate-500/20 p-2 px-3 rounded-xl flex text-[12px] items-center text-[#ddd] gap-2">
            <img src={WhatsappIcon} alt="" className="max-w-7" />
            Chat
          </button>
          <button onClick={() => callHelpMessage()} className="bg-slate-500/20 p-2 px-3 rounded-xl flex text-[12px] items-center text-[#ddd] gap-2">
            <img src={CallIcon} alt="" className="max-w-6" />
            Call
          </button>
          </div>
        </div>
      </div>
    </Div100vh>
  );
}
